// localStorage数据管理工具
const STORAGE_KEY = 'blog_posts';

// 封面图片列表 - 用于自动生成文章封面
const COVER_IMAGES = [
  'https://picsum.photos/600/300?random=1',
  'https://picsum.photos/600/300?random=2',
  'https://picsum.photos/600/300?random=3',
  'https://picsum.photos/600/300?random=4',
  'https://picsum.photos/600/300?random=5',
  'https://picsum.photos/600/300?random=6',
  'https://picsum.photos/600/300?random=7',
  'https://picsum.photos/600/300?random=8',
  'https://picsum.photos/600/300?random=9',
  'https://picsum.photos/600/300?random=10'
];

// 初始化数据
export const initializeData = () => {
  const data = localStorage.getItem(STORAGE_KEY);
  if (!data) {
    // 如果localStorage中没有数据，则使用mock数据初始化
    const mockPosts = [
      {
        id: 1,
        title: "React Hooks 使用指南",
        author: "张三",
        date: "2025-01-15",
        tags: ["React", "Hooks", "JavaScript"],
        excerpt: "React Hooks 是 React 16.8 引入的新特性，它让你可以在不编写 class 的情况下使用 state 以及其他的 React 特性。",
        content: `# React Hooks 使用指南

React Hooks 是 React 16.8 引入的新特性，它让你可以在不编写 class 的情况下使用 state 以及其他的 React 特性。

## 什么是 Hooks？

Hooks 是一些可以让你在函数组件里"钩入" React state 及生命周期等特性的函数。

## 基础 Hooks

### useState

\`\`\`javascript
import React, { useState } from 'react';

function Example() {
  const [count, setCount] = useState(0);

  return (
    <div>
      <p>You clicked {count} times</p>
      <button onClick={() => setCount(count + 1)}>
        Click me
      </button>
    </div>
  );
}
\`\`\`

### useEffect

\`\`\`javascript
import React, { useState, useEffect } from 'react';

function Example() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    document.title = \`You clicked $\{count} times\`;
  });

  return (
    <div>
      <p>You clicked {count} times</p>
      <button onClick={() => setCount(count + 1)}>
        Click me
      </button>
    </div>
  );
}
\`\`\`

## 自定义 Hooks

你可以创建自己的 Hooks 来复用组件逻辑。自定义 Hook 是一个 JavaScript 函数，其名称以 "use" 开头，函数内部可以调用其他的 Hook。

\`\`\`javascript
import { useState, useEffect } from 'react';

function useFriendStatus(friendID) {
  const [isOnline, setIsOnline] = useState(null);

  useEffect(() => {
    function handleStatusChange(status) {
      setIsOnline(status.isOnline);
    }

    ChatAPI.subscribeToFriendStatus(friendID, handleStatusChange);
    return () => {
      ChatAPI.unsubscribeFromFriendStatus(friendID, handleStatusChange);
    };
  });

  return isOnline;
}
\`\`\`
`,
        coverImage: COVER_IMAGES[0]
      },
      {
        id: 2,
        title: "JavaScript 异步编程详解",
        author: "李四",
        date: "2025-01-10",
        tags: ["JavaScript", "异步", "Promise"],
        excerpt: "JavaScript 异步编程是现代前端开发中非常重要的概念，本文将详细介绍回调函数、Promise、async/await 等异步处理方式。",
        content: `# JavaScript 异步编程详解

JavaScript 异步编程是现代前端开发中非常重要的概念，本文将详细介绍回调函数、Promise、async/await 等异步处理方式。

## 回调函数

最传统的异步处理方式就是回调函数：

\`\`\`javascript
function fetchData(callback) {
  setTimeout(() => {
    callback('数据获取成功');
  }, 1000);
}

fetchData((data) => {
  console.log(data);
});
\`\`\`

## Promise

Promise 是 ES6 引入的异步编程解决方案：

\`\`\`javascript
function fetchData() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve('数据获取成功');
    }, 1000);
  });
}

fetchData()
  .then(data => console.log(data))
  .catch(error => console.error(error));
\`\`\`

## async/await

ES2017 引入的 async/await 让异步代码看起来像同步代码：

\`\`\`javascript
async function fetchData() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve('数据获取成功');
    }, 1000);
  });
}

async function getData() {
  try {
    const data = await fetchData();
    console.log(data);
  } catch (error) {
    console.error(error);
  }
}
\`\`\`
`,
        coverImage: COVER_IMAGES[1]
      },
      {
        id: 3,
        title: "CSS Grid 布局完全指南",
        author: "王五",
        date: "2025-01-05",
        tags: ["CSS", "Grid", "布局"],
        excerpt: "CSS Grid 布局是 CSS 中强大的二维布局系统，它可以让网页布局变得更加灵活和强大。",
        content: `# CSS Grid 布局完全指南

CSS Grid 布局是 CSS 中强大的二维布局系统，它可以让网页布局变得更加灵活和强大。

## 基本概念

CSS Grid Layout 将网页划分成一个个网格，可以任意组合不同的网格，做出各种各样的布局。

## 容器属性

### display: grid

设置容器为网格布局：

\`\`\`css
.container {
  display: grid;
}
\`\`\`

### grid-template-columns 和 grid-template-rows

设置列宽和行高：

\`\`\`css
.container {
  display: grid;
  grid-template-columns: 100px 100px 100px;
  grid-template-rows: 50px 50px;
}
\`\`\`

### grid-gap

设置网格之间的间距：

\`\`\`css
.container {
  display: grid;
  grid-template-columns: 100px 100px 100px;
  grid-gap: 20px;
}
\`\`\`

## 项目属性

### grid-column 和 grid-row

指定项目放置的位置：

\`\`\`css
.item {
  grid-column: 1 / 3;
  grid-row: 1;
}
\`\`\`
`,
        coverImage: COVER_IMAGES[2]
      }
    ];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(mockPosts));
    return mockPosts;
  }
  return JSON.parse(data);
};

// 获取所有文章
export const getAllPosts = () => {
  return initializeData();
};

// 根据ID获取文章
export const getPostById = (id) => {
  const posts = getAllPosts();
  return posts.find(post => post.id === parseInt(id));
};

// 添加新文章
export const addPost = (post) => {
  const posts = getAllPosts();
  // 为新文章生成ID
  const newId = posts.length > 0 ? Math.max(...posts.map(p => p.id)) + 1 : 1;
  
  // 为新文章分配一个随机封面图
  const coverImage = COVER_IMAGES[Math.floor(Math.random() * COVER_IMAGES.length)];
  
  const newPost = {
    ...post,
    id: newId,
    date: new Date().toISOString().split('T')[0], // YYYY-MM-DD格式
    coverImage
  };
  posts.push(newPost);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(posts));
  return newPost;
};

// 更新文章
export const updatePost = (updatedPost) => {
  const posts = getAllPosts();
  const index = posts.findIndex(post => post.id === updatedPost.id);
  if (index !== -1) {
    posts[index] = updatedPost;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(posts));
    return updatedPost;
  }
  return null;
};

// 删除文章
export const deletePost = (id) => {
  let posts = getAllPosts();
  posts = posts.filter(post => post.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(posts));
};

// 搜索文章
export const searchPosts = (term) => {
  const posts = getAllPosts();
  if (!term) return posts;
  
  return posts.filter(post => 
    post.title.toLowerCase().includes(term.toLowerCase()) ||
    post.excerpt.toLowerCase().includes(term.toLowerCase()) ||
    post.content.toLowerCase().includes(term.toLowerCase()) ||
    post.tags.some(tag => tag.toLowerCase().includes(term.toLowerCase()))
  );
};